/**
 * istanbul ignore file
 *
 * @format
 */

/** @format */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import {
	atcSnackbarClosed,
	selectAtcAirballMeassage,
	selectAtcSuccess
} from '@pdp/add-to-cart/data-access';

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertErrorOutlined,
	homefieldIconSignCancel
} from '@dsg-tech/homefield-angular-icons';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'pdp-component-snackbar',
	templateUrl: './snackbar.component.html',
	styleUrl: './snackbar.component.scss',
	imports: [AsyncPipe, HomefieldIconLibraryModule]
})
export class SnackbarComponent implements OnInit, OnDestroy {
	/**
	 * @description Airball Message
	 */
	airballMessage$ = this.store.select(selectAtcAirballMeassage);

	title = 'Attention';

	/**
	 * @description
	 * SnackBar
	 */
	isSnackBarOpen = false;
	atcSuccess: boolean;

	private destroy$: Subject<void> = new Subject();

	constructor(
		private readonly store: Store,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconAlertErrorOutlined,
			homefieldIconSignCancel
		]);
	}

	ngOnInit() {
		this.store
			.select(selectAtcSuccess)
			.pipe(takeUntil(this.destroy$))
			.subscribe((atcSuccess) => {
				this.atcSuccess = atcSuccess;
				this.isSnackBarOpen = this.atcSuccess === false;
			});
	}

	closeMessage(): void {
		this.isSnackBarOpen = false;
		this.store.dispatch(atcSnackbarClosed());
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
